export default "__VITE_ASSET__BCGlobeq__"